export default __webpack_public_path__ + "static/pskhu-cerkov-useknoveniya-glavy-ioanna-predtechi-d6b154ae94068d29cda549ee43b6aa53.jpg";